import { apiClient } from '../../shared/api/client';

export interface PosCatalogProduct {
  id: string;
  code: string;
  name: string;
  salePrice: number;
  unit: string;
  stock: number;
}

interface BackendProduct {
  id: string;
  sku?: string | null;
  barcode?: string | null;
  name: string;
  price?: number | null;
  unit?: string | null;
}

interface BackendBalance {
  productId: string;
  available?: number | null;
  onHand?: number | null;
}

/**
 * Catálogo PDV a partir de endpoints reais (todo-review5 P3).
 * - `GET /api/v1/products` (array; tenant da sessão, SDD §7.1)
 * - `GET /api/v1/inventory/balance` (array; soma `available` por produto)
 * Sem rota aninhada `/tenants/:id/pos/products` (inexistente no backend).
 */
export async function fetchPosCatalog(search?: string): Promise<PosCatalogProduct[]> {
  const [products, balances] = await Promise.all([
    apiClient.get<BackendProduct[]>('/products'),
    apiClient.get<BackendBalance[]>('/inventory/balance').catch(() => [] as BackendBalance[]),
  ]);

  const stockByProduct = new Map<string, number>();
  for (const balance of balances) {
    const qty = balance.available ?? balance.onHand ?? 0;
    stockByProduct.set(balance.productId, (stockByProduct.get(balance.productId) ?? 0) + qty);
  }

  const query = search?.trim().toLowerCase() ?? '';
  return products
    .filter((p) => {
      if (!query) return true;
      return (
        p.name.toLowerCase().includes(query) ||
        (p.sku ?? '').toLowerCase().includes(query) ||
        (p.barcode ?? '').toLowerCase().includes(query)
      );
    })
    .map((p) => ({
      id: p.id,
      code: p.sku ?? p.barcode ?? p.id,
      name: p.name,
      salePrice: p.price ?? 0,
      unit: p.unit ?? 'UN',
      stock: stockByProduct.get(p.id) ?? 0,
    }));
}
